import { Swiper, Navigation, Pagination } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerHome = new Swiper(".banner__home", {
        watchOverflow: true,
        navigation: {
            nextEl: '.home-button-next',
            prevEl: '.home-button-prev',
        },
        pagination: {
            el: ".home-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerAbout = new Swiper(".banner__about", {
        watchOverflow: true,
        slidesPerView: 4,
        navigation: {
            nextEl: '.about-button-next',
            prevEl: '.about-button-prev',
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
            },
            900: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });

    let bannerNotices = new Swiper(".slide__notices", {
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.notices-button-next',
            prevEl: '.notices-button-prev',
        },
        pagination: {
            el: ".notices-pagination",
            type: "bullets",
            clickable: true,
        },
    });
};
